import { SimpleActionItemEditOverride } from 'Resources/SimpleActionItem';
import { BulkCommunicationOverride } from 'Resources/BulkCommunication';
import { HouseholdEscalationOverride } from './HouseholdEscalation';
import { ExternalFormOverride } from './ExternalForm';
import { CuratedContentArticleOverride } from './CuratedContentArticle';
import { BulkCommunicationPreviewOverride } from './BulkCommunicationPreview';
// DO NOT REMOVE - GENERATOR REPLACE ME - MODAL IMPORTS

const typeMetaOverrides = {
  simpleActionItem: SimpleActionItemEditOverride,
  householdEscalation: HouseholdEscalationOverride,
  externalForm: ExternalFormOverride,
  bulkCommunication: BulkCommunicationOverride,
  curatedContentArticle: CuratedContentArticleOverride,
  bulkCommunicationPreview: BulkCommunicationPreviewOverride,
  // DO NOT REMOVE - GENERATOR REPLACE ME - MODAL DICTIONARY
};

export default typeMetaOverrides;
